import { render, staticRenderFns } from "./EssayDetail.vue?vue&type=template&id=e06b2f84&scoped=true"
import script from "./EssayDetail.vue?vue&type=script&lang=js"
export * from "./EssayDetail.vue?vue&type=script&lang=js"
import style0 from "./EssayDetail.vue?vue&type=style&index=0&id=e06b2f84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06b2f84",
  null
  
)

export default component.exports